import { useEffect } from 'react';

const isDevelopment = process.env.NODE_ENV === 'development';

export const useStackTrace = (error: unknown) => {
  useEffect(() => {
    const OVERLAY_NAME = 'vite-error-overlay';
    const ErrorOverlay = customElements.get(OVERLAY_NAME);
    const overlayActive = !!document.querySelector(OVERLAY_NAME);

    if (error && ErrorOverlay && isDevelopment && !overlayActive) {
      document.body.appendChild(new ErrorOverlay(error));
    }
  }, [error]);
};
